import {
  FETCH_SETTINGS,
  FETCH_SETTINGS_SUCCESS,
  FETCH_SETTINGS_FAILED,
  EDIT_SETTINGS,
  CLEAR_SETTINGS_ERROR
} from "../store/types";

import store from '../store/store';
import { getRecord, saveRecord, subscribeToRecord } from '../data/appRecords';

export const fetchSettings= () => (dispatch) => {
  dispatch({
    type: FETCH_SETTINGS,
    payload: null,
  });

  let unsubscribe = () => {};
  try {
    unsubscribe = subscribeToRecord('settings', 'main', (settings) => {
      if (settings) {
        dispatch({ type: FETCH_SETTINGS_SUCCESS, payload: settings });
      }
    });
  } catch (error) {
    console.warn('Realtime settings subscription unavailable:', error.message);
  }

  getRecord('settings', 'main').then((settings) => {
    dispatch(settings
      ? { type: FETCH_SETTINGS_SUCCESS, payload: settings }
      : { type: FETCH_SETTINGS_FAILED, payload: 'Unable to fetch settings.' });
  }).catch((error) => {
    dispatch({ type: FETCH_SETTINGS_FAILED, payload: error.message });
  });

  return unsubscribe;
};

export const editSettings = (settings) => async (dispatch) => {
  dispatch({
    type: EDIT_SETTINGS,
    payload: settings
  });
  try {
    await saveRecord('settings', 'main', settings);
    alert(store.getState().languagedata.defaultLanguage.updated);
  } catch (error) {
    dispatch({ type: FETCH_SETTINGS_FAILED, payload: error.message });
  }
};

export const clearSettingsViewError = () => (dispatch) => {
  dispatch({
    type: CLEAR_SETTINGS_ERROR,
    payload: null
  });
};
